import { V4 } from '@moleculeone/utils';

import { CompoundEditorActions, MolEvent, Space } from '../hooks';

import { DASHED, WEDGE } from './molecule-object/molecule-object.actions';

type getContextMenuItemsArgs = {
  event: MolEvent;
  compound: Space;
  actions: CompoundEditorActions;
};

type Item = [string | (() => void), string];

export const getContextMenuItems = ({ event, compound, actions }: getContextMenuItemsArgs) => {
  const generalItems: Item[] = [];
  const atomItems: Item[] = [];
  const bondItems: Item[] = [];
  if (event.empty) {
    generalItems.push(
      ['pick-element', 'Add element'],
      [() => actions.onFlipMol(V4.vectx), 'Flip vertically'],
      [() => actions.onFlipMol(V4.vecty), 'Flip horizontally']
    );
  }
  if (event.atom) {
    atomItems.push(['pick-element', 'Replace element']);
  }
  const bond = event.bond && compound.mol.bonds[event.idx];
  if (bond) {
    const wedge = bond.type === WEDGE;
    const dashed = bond.type === DASHED;
    const chiral = wedge || dashed;
    const geometric = bond.geometry != null;
    const double = bond.order === 2;
    bondItems.push([() => actions.onRotateBond(event.idx), 'Rotate around bond']);
    if (!dashed) {
      bondItems.push([() => actions.onSetChirality(event.idx, DASHED), 'Dashed bond']);
    }
    if (!wedge) {
      bondItems.push([() => actions.onSetChirality(event.idx, WEDGE), 'Wedge bond']);
    }
    if (chiral) {
      bondItems.push(
        [() => actions.onChangeDir(event.idx), 'Change direction'],
        [() => actions.onClearChirality(event.idx), 'Clear chirality']
      );
    }
    if (!geometric && double) {
      bondItems.push([() => actions.onSetGeometry(event.idx), 'Assign geometry']);
    }
    if (geometric) {
      bondItems.push(
        [() => actions.onChangeGeometry(event.idx), 'Change geometry'],
        [() => actions.onClearGeometry(event.idx), 'Clear geometry']
      );
    }
  }
  generalItems.push([compound.clear, 'Clear'], [compound.redraw, 'Redraw']);
  return [
    {
      groupLabel: 'Atom',
      items: atomItems,
    },
    {
      groupLabel: 'Bond',
      items: bondItems,
    },
    {
      groupLabel: 'Compound',
      items: generalItems,
    },
  ];
};
